import { render, staticRenderFns } from "./ParcelInfo.vue?vue&type=template&id=0ce7cdf4&"
import script from "./ParcelInfo.vue?vue&type=script&lang=js&"
export * from "./ParcelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports